import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Convertor } from 'src/infrastructure/core/convertor';
import { Reviews } from 'src/models/DTO/reviews/reviewCollection';
import { ImagesService } from 'src/services/request/images/images.service';
import { ReviewsService } from 'src/services/request/reviews/reviews.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.css']
})
export class ReviewsComponent extends HistoryBaseComponent implements OnInit {

  selectedOrder: string = "Най-нови";
  selectedInterval: string = "Всички";

  private _reviews: Reviews = { data: [] };
  private _categorised: { [key:string]: object[] } = {
    1: [],
    2 : [],
    3 : [],
    4 : [],
    5 : [],
  };
  private _order: string = "newest";
  private _interval: number = 0;
  private _productId: string = '';

  constructor(
    private reviewsService: ReviewsService,
    private activatedRoute: ActivatedRoute,
    private imagesService: ImagesService,
    private modalService: NgbModal,
    protected location: Location,
    protected historyService: HistoryService
  ) { 
    super(location, historyService);
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this._productId = params.id;
      this.loadReviews()
    })
  }

  private loadReviews() {
    this.reviewsService.getProductReviews(this._productId, 1, 400, this._order).subscribe(reviews => {
      this._reviews = reviews;
      this._reviews.data.forEach(review => {
        this.imagesService.getImagesForProduct("USER", review.user!.uuid, 'logo').subscribe(images => {
          review.user!.userImage = images.data[0].original.url;
        })
      })
      this.categorise();
    })
  }

  private categorise() {
    for(let i = 1; i < 6; i++) {
      let categorised = this._reviews!.data.filter(reviews => reviews.rating == i);
      this._categorised[i] = categorised.sort((reviewA, reviewB) => {
        if (reviewA.rating > reviewB.rating) {
          return 1;
        }
        return 0;
      })
    }
  }

  get reviews() {
    return this._reviews.data;
  }

  get categorised() {
    return this._categorised;
  }

  get avrRating() {
    let ratingSum = 0;
    this._reviews?.data.forEach( review => {
      ratingSum += review.rating;
    })
    return ratingSum ? (ratingSum / this.reviews!.length) : 0;
  }

  get avrRatingAsString() {
    let ratingSum = 0;
    this._reviews?.data.forEach( review => {
      ratingSum += review.rating;
    })
    return ratingSum ? (ratingSum / this.reviews!.length).toFixed(1) : '0.0';
  }

  selectOrder(label:string, order: string){
    this.selectedOrder = label;
    this._order = order;
    this.loadReviews();
  }

  selectFilter(label:string, filter: number){
    this.selectedInterval = label;
    this._interval = filter;
    this.loadReviews();
  }

  userName(review: any) {
    return (review.user?.fist_name || 'Ivan') + ' ' + (review.user?.last_name || 'Grigorov')
  }

  date(review: any) {
    return Convertor.convertDate.pointToDash(review.updated_at)
  }

  public open(modal: any) {
    this.modalService.open(modal, { size: 'sm',  windowClass: 'loginModal' })
  }

}
